export const PC_TITLE = "Payment Connection";
// DOM id other pages pass as /user-info's scrollTo to land on this section.
export const PAYMENT_CONNECTION_SECTION_ID = "payment-connection";
export const PC_SUBTITLE =
  "Create and send payment requests to clients directly from your Morph jobs.";
export const PC_FEE_DISCLAIMER =
  "Processing fee: Stripe 2.9% + $0.30 + Morph 1% per transaction";

export const PC_STATE = {
  LOADING: "loading",
  NOT_CONNECTED: "not_connected",
  INCOMPLETE: "incomplete",
  PENDING: "pending",
  CONNECTED: "connected",
  DISABLED: "disabled",
  ERROR: "error",
  ERROR_FETCH: "error_fetch",
  NO_COMPANY: "no_company",
};

export const STATE_META = {
  [PC_STATE.INCOMPLETE]: {
    dotColor: "#f5a623",
    label: "Incomplete",
    body: "Complete your payment account setup to start accepting payments.",
  },
  [PC_STATE.PENDING]: {
    dotColor: "#f5a623",
    label: "Pending Verification",
    body: "Your account is being reviewed. This usually takes 1–2 business days.",
  },
  [PC_STATE.CONNECTED]: {
    dotColor: "#28a745",
    label: "Connected",
    body: null,
  },
  [PC_STATE.DISABLED]: {
    dotColor: "#6c757d",
    label: "Disabled",
    body: "Payments are turned off. You can re-enable at any time.",
  },
  [PC_STATE.ERROR]: {
    dotColor: "#dc3545",
    label: "Error",
    body: "There's an issue with your payment account. Payments are currently disabled.",
  },
};

export const NOT_CONNECTED_TEXT = "No connection yet";
// Refresh is part of the instruction because the account fetch only runs on mount.
export const NO_COMPANY_TEXT =
  "Fill in the required fields above, including Company Name, then click Save and refresh this page. Your payment account belongs to your company, so we need the company first.";
export const DETAIL_PLACEHOLDER = "Not added yet";

// REACT_APP_URL is a *.morph-technologies.com host, required by the backend
// redirect-URL allowlist (window.location.origin would fail from localhost).
export const buildRedirectUrls = () => {
  const base = process.env.REACT_APP_URL || window.location.origin;
  return {
    return_url: `${base}/user-info?payment_onboarding=done`,
    refresh_url: `${base}/user-info?payment_onboarding=refresh`,
  };
};
